// import 'babel-polyfill'
import 'es6-promise/auto'
import "@babel/polyfill"

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import VueLazyLoad from 'vue-lazyload'

import storage from './utils/storage.js'
import { redicectCheck } from './utils/index.js'

import * as Api from './config/http.js';
import VueI18n from 'vue-i18n'
// import BaiduMap from 'vue-baidu-map'
import VueYoutube from 'vue-youtube'

import VueAliplayerV2 from 'vue-aliplayer-v2'

import VideoPlayer from 'vue-video-player'
import 'videojs-contrib-hls'

// import VueGtm from "vue-gtm";
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
Vue.use(VueImageSwipe)

Vue.use(VideoPlayer)
Vue.use(VueYoutube)
Vue.use(VueAliplayerV2);
Vue.use(VueI18n)
Vue.use(VueLazyLoad, {
  error: require('./assets/images/loading.png'),
  loading: require('./assets/images/loading.png')
})


// Vue.use(VueGtm, {
//   id: "GTM-N86FZGX", // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
//   // queryParams: {
//   //   // Add url query string when load gtm.js with GTM ID (optional)
//   //   gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
//   //   gtm_preview: "env-4",
//   //   gtm_cookies_win: "x",
//   // },
//   defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
//   enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: true, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//   ignoredViews: ["homepage"], // Don't trigger events for specified router names (case insensitive) (optional)
//   trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
// });


// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: '3umyuEDzQz9qbQzLh0zqW2RO7WbLncIe'
// })

let currentlange = 'en'
localStorage.setItem('lange', currentlange)
const i18n = new VueI18n({ 
   locale: localStorage.getItem('lange') || currentlange, // 定义默认语言为中文 
   messages: {   
      'en': require('@/assets/languages/en.json'),
      'zh': require('@/assets/languages/zh.json'),  
    }
});
  

var message = (text, type = 'success') => {
  Vue.prototype.$message({
    showClose: true,
    message: text,
    type: type,
    duration: 3000
  })
}
Vue.prototype.$msg = message;
Vue.config.productionTip = false
Vue.prototype.$api = Api;
Vue.prototype.$storage = storage;

router.beforeEach((to, from, next) => {

  redicectCheck()
  
  if(window.location.href.indexOf('web/#') > -1) {
    window.location.href = window.location.href.replace('web/#', 'web')
    return
  }
  
  if(to.params.invite || to.query.invite || to.params.invitecode || to.query.invitecode) {
    window.localStorage.setItem('invite', to.params.invite || to.query.invite || to.params.invitecode || to.query.invitecode )
  }


  if (to.meta.title) {
    if (store.state.config.shop_name) {
      document.title = 'Sanlida Archery-' +  i18n.t(to.meta.l18ntitle) 
    } else {
      document.title = 'Sanlida Archery-' + i18n.t(to.meta.l18ntitle)
    }
  }
  next()
})

if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<=9){
  console.log('请升级浏览器')
}else{
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

